import React from "react";
import "./SectionDivider.css";

const SectionDivider = () => {
  return <div className="section-divider"></div>;
};

export default SectionDivider;